import { createContext } from "react";
import type { AdminUserBloc } from "@/application/admin_user/admin_user_bloc";
import type { ProvisioningListBloc } from "@/application/provisioning/provisioning_list_bloc";
import type { ProvisioningBloc } from "@/application/provisioning/provisioning_bloc";
import type { DashboardBloc } from "@/application/provisioning/dashboard_bloc";
import type { ProvisioningRepository } from "@/application/provisioning/provisioning_repository";

export interface AdminAppContextValue {
  adminUserBloc: AdminUserBloc;
  provisioningRepo: ProvisioningRepository;
  provisioningListBloc: ProvisioningListBloc;
  provisioningBloc: ProvisioningBloc;
  dashboardBloc: DashboardBloc;
}

export const AdminAppContext = createContext<AdminAppContextValue | null>(null);
